<template>
  <div class="max-w-5xl mx-auto">

    <div
      v-if="cosignerRecommendationCard"
      class="flex flex-col my-48"
    >
      <h4 class="text-center text-lg font-bold mb-2">
        {{ cosignerRecommendationCard.title }}
      </h4>
      <span class="w-24 h-1 mx-auto bg-green-500 mb-6"></span>
      <div class="flex flex-row justify-center">
        <div
          v-for="(item, i) in cosignerRecommendationCard.data"
          :key="`cosignerRecommendationCard-${item}-${i}`"
          class="flex flex-col w-1/2 md:w-1/4 lg:w-1/6 text-center justify-center p-2"
        >
          <div class="flex flex-col py-6 bg-white shadow-md rounded">
            <h5 class="font-bold text-3xl">{{ item.value }}</h5>
            <p class="text-sm text-gray-500">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <p class="text-center p-5 bg-gray-100 mt-8 rounded mx-0 lg:mx-2"
         v-html="cosignerRecommendationCard.subtitle"
      ></p>
    </div>

    <div
      v-if="rateTypeRecommendationCard"
      class="flex flex-col my-48"
    >
      <h4 class="text-center text-lg font-bold mb-2">
        {{ rateTypeRecommendationCard.title }}
      </h4>
      <span class="w-24 h-1 mx-auto bg-green-500 mb-6"></span>
      <div class="flex flex-row flex-wrap justify-center">
        <div
          v-for="(item, i) in rateTypeRecommendationCard.data"
          :key="`rateTypeRecommendationCard-${item}-${i}`"
          class="flex flex-col w-1/2 md:w-1/4 lg:w-1/6 text-center justify-center p-2"
        >
          <div class="flex flex-col py-6 bg-white shadow-md rounded">
            <h5 class="font-bold text-3xl">{{ item.value }}%</h5>
            <p class="text-sm text-gray-500">{{ item.title.replace(' Rate', '') }}</p>
          </div>
        </div>
      </div>
      <p
        class="text-center p-5 bg-gray-100 mt-8 rounded mx-0 lg:mx-2"
        v-html="rateTypeRecommendationCard.subtitle"
      ></p>
    </div>

    <div
      v-if="repaymentPlanRecommendationCard"
      class="flex flex-col my-48"
    >
      <h4 class="text-center text-lg font-bold mb-2">
        {{ repaymentPlanRecommendationCard.title }}
      </h4>
      <span class="w-24 h-1 mx-auto bg-green-500 mb-6"></span>
      <div class="flex flex-row flex-wrap justify-center">
        <div
          v-for="(item, i) in repaymentPlanRecommendationCard.data"
          :key="`repaymentPlanRecommendationCard-${item}-${i}`"
          class="flex flex-col w-1/2 md:w-1/4 lg:w-1/6 text-center justify-center p-2"
        >
          <div class="flex flex-col py-6 bg-white shadow-md rounded">
            <h5 class="font-bold text-3xl">{{ item.value }}%</h5>
            <p class="text-sm text-gray-500">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <p
        class="text-center p-5 bg-gray-100 mt-8 rounded mx-0 lg:mx-2"
        v-html="repaymentPlanRecommendationCard.subtitle"
      >
      </p>
    </div>

    <div
      v-if="loanTermRecommendationCard"
      class="flex flex-col my-48"
    >
      <h4 class="text-center text-lg font-bold mb-2">
        {{ loanTermRecommendationCard.title }}
      </h4>
      <span class="w-24 h-1 mx-auto bg-green-500 mb-6"></span>
      <div class="flex flex-row flex-wrap justify-center">
        <div
          v-for="(item, i) in loanTermRecommendationCard.data"
          :key="`loanTermRecommendation-${item}-${i}`"
          class="flex flex-col w-1/2 md:w-1/4 lg:w-1/6 text-center justify-center p-2"
        >
          <div class="flex flex-col py-6 bg-white shadow-md rounded">
            <h5 class="font-bold text-3xl">{{ item.value }}</h5>
            <p class="text-sm text-gray-500">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <p class="text-center p-5 bg-gray-100 mt-8 rounded mx-0 lg:mx-2"
         v-html="loanTermRecommendationCard.subtitle"
      ></p>
    </div>

    <div
      v-if="creditScoreRecommendationCard"
      class="flex flex-col my-48"
    >
      <h4 class="text-center text-lg font-bold mb-2">
        {{ creditScoreRecommendationCard.title }}
      </h4>
      <span class="w-24 h-1 mx-auto bg-green-500 mb-6"></span>
      <div class="flex flex-row justify-center flex-wrap">
        <div
          v-for="(item, i) in creditScoreRecommendationCard.data"
          :key="`creditScoreRecommendationCard-${item}-${i}`"
          class="flex flex-col w-1/2 md:w-1/4 lg:w-1/6 text-center justify-center p-2"
        >
          <div class="flex flex-col py-6 bg-white shadow-md rounded">
            <h5 class="font-bold text-3xl">{{ item.value }}%</h5>
            <p class="text-sm text-gray-500">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <p
        class="text-center p-5 bg-gray-100 mt-8 rounded mx-0 lg:mx-2"
        v-html="creditScoreRecommendationCard.subtitle"
      >
      </p>
    </div>

    <div
      v-if="lenderRecommendationCard"
      class="flex flex-col my-48"
    >
      <h4 class="text-center text-lg font-bold mb-2">
        {{ lenderRecommendationCard.title }}
      </h4>
      <span class="w-24 h-1 mx-auto bg-green-500 mb-6"></span>
      <div class="flex flex-row flex-wrap">
        <div
          v-for="(item, i) in lenderRecommendationCard.data"
          :key="`lenderRecommendationCard-${item}-${i}`"
          class="flex flex-col w-1/2 md:w-1/3 lg:w-1/6 text-center justify-center p-2"
        >
          <div class="flex flex-col py-6 bg-white shadow-md rounded">
            <h5 class="font-bold text-3xl">{{ item.value }}%</h5>
            <p class="text-sm text-gray-500">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <p class="text-center p-5 bg-gray-100 mt-8 rounded mx-0 lg:mx-2"
         v-html="lenderRecommendationCard.subtitle"
      ></p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'RecommendationCards',
  computed: {
    ...mapState('base', [
      'creditScores',
      'cosignerCreditScores',
      'degrees',
      'rateTypes',
      'repaymentPlans',
      'lenders',
    ]),
    ...mapGetters('submission', [
      'cosignerRecommendation',
      'creditScoreRecommendation',
      'lenderRecommendation',
      'loanTermRecommendation',
      'rateTypeRecommendation',
      'repaymentPlanRecommendation',
    ]),

    cosignerRecommendationCard() {
      if (this.cosignerRecommendation) {
        const { averageApr, averageCosignedApr } = this.cosignerRecommendation;
        const fixedAverageApr = Number(averageApr || 0).toFixed(2);
        const fixedAverageCosignedApr = Number(averageCosignedApr || 0).toFixed(2);
        return {
          title: 'With co-signer vs without',
          subtitle: `Loans with a co-signer have typically lower APRs than those without.
          If you can get a co-signer, it might be worth checking your difference in rate with or
          without one.`,
          data: [
            {
              value: `${fixedAverageCosignedApr}%`,
              title: 'Co-signer',
            },
            {
              value: `${fixedAverageApr}%`,
              title: 'w/o Co-signer',
            },
          ],
        };
      }
      return null;
    },

    lenderRecommendationCard() {
      if (this.lenderRecommendation) {
        const data = Object.keys(this.lenderRecommendation).map((id) => {
          const { name } = this.findObjectValueByKeyId('lenders', id);
          return {
            value: Number(this.lenderRecommendation[id]).toFixed(2),
            title: name,
          };
        })
          .sort((a, b) => a.value - b.value);
        return {
          title: 'Average rates by Lenders',
          subtitle: `These are the average rates that these lenders have quoted others like you.
          You should use this information directionally as these rates are averaged across loans
          of all sizes, terms, and repayment methods.`,
          data,
        };
      }
      return null;
    },

    loanTermRecommendationCard() {
      if (this.loanTermRecommendation) {
        const data = Object.keys(this.loanTermRecommendation).map((key) => {
          return {
            value: `${Number(this.loanTermRecommendation[key]).toFixed(2)}%`,
            title: `${key} years`,
          };
        });
        return {
          title: 'Average Rates by Years',
          subtitle: `APRs typically increase as the length of loan increases. This is because
           the lender is taking a higher risk in extending you a longer repayment period.`,
          data,
        };
      }
      return null;
    },

    rateTypeRecommendationCard() {
      if (this.rateTypeRecommendation) {
        const data = Object.keys(this.rateTypeRecommendation).map((id) => {
          const { type } = this.findObjectValueByKeyId('rateTypes', id);
          return {
            value: Number(this.rateTypeRecommendation[id]).toFixed(2),
            title: type,
          };
        })
          .sort((a, b) => a.title - b.title);
        return {
          title: 'Fixed vs Variable Rate',
          subtitle: `Generally, LeverEdge members have preferred fixed rate loans—which makes
          sense most of the time—but this year variable rates are so low that many members are
          considering them instead. We put together a
          <a
            href="https://leveredge.org/fixed-vs-variable-20-21"
            class="text-green-500 underline"
            target="_blank"
            rel="noreferrer noopener"
          >
            resource here<svg
              aria-hidden="true"
              role="img"
              viewBox="0 0 512 512"
              width="12"
              height="12"
              class="inline mb-1 ml-1"
            >
              <path fill="currentColor" d="M440,256H424a8,8,0,0,0-8,8V464a16,16,0,0,1-16,16H48a16,
              16,0,0,1-16-16V112A16,16,0,0,1,48,96H248a8,8,0,0,0,8-8V72a8,8,0,0,0-8-8H48A48,48,0,
              0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V264A8,8,0,0,0,440,256ZM500,0,
              364,.34a12,12,0,0,0-12,12v10a12,12,0,0,0,12,12L454,34l.7.71L131.51,357.86a12,12,0,0,
              0,0,17l5.66,5.66a12,12,0,0,0,17,0L477.29,57.34l.71.7-.34,90a12,12,0,0,0,12,12h10a12,
              12,0,0,0,12-12L512,12A12,12,0,0,0,500,0Z"></path>
            </svg>
          </a> for you to make an informed decision.`,
          data,
        };
      }
      return null;
    },

    repaymentPlanRecommendationCard() {
      if (this.repaymentPlanRecommendation) {
        const data = Object.keys(this.repaymentPlanRecommendation).map((id) => {
          const { plan } = this.findObjectValueByKeyId('repaymentPlans', id);
          return {
            value: Number(this.repaymentPlanRecommendation[id]).toFixed(2),
            title: plan,
          };
        })
          .sort((a, b) => a.title - b.title);
        return {
          title: 'Average Rates by Repayment Plan',
          subtitle: `Different lenders offer different repayment plans. You can choose to start
          paying your loan and interest back <span class="font-bold italic">immediately</span>
          or choose to <span class="font-bold italic">fully defer</span> payments until
          after you graduate. You can also choose something in the middle, where you pay
          <span class="font-bold italic">interest only</span> while in-school or pay a
          <span class="font-bold italic">fixed amount</span> every month. `,
          data,
        };
      }
      return null;
    },

    creditScoreRecommendationCard() {
      if (this.creditScoreRecommendation) {
        const data = Object.keys(this.creditScoreRecommendation).map((id) => {
          const { score } = this.findObjectValueByKeyId('creditScores', id);
          return {
            value: Number(this.creditScoreRecommendation[id]).toFixed(2),
            title: score,
          };
        })
          .sort((a, b) => a.title - b.title);
        return {
          title: 'Average APR vs Credit Score variation',
          subtitle: `Improving your credit score can have a positive impact on your APR. It is
          important to note that lenders typically have their own internal methods to assess
          your ability to pay back the loan.`,
          data,
        };
      }
      return null;
    },
  },
  methods: {
    findObjectValueByKeyId(key, id) {
      return this[key].find((item) => item.id === Number(id));
    },
  },
};
</script>
